import { useState } from 'react'
import { useLang } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'

const CheckCode = ({
  doSubscribe,
  codeExact,
  onConfirmCode,
  mail,
  onCancel,
}) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng

  const [code, setCode] = useState('')
  const onCodeChange = (e) => {
    setCode(e.target.value)
  }
  return (
    <>
      {!codeExact && (
        <div className="notification is-danger is-light">
          <span className="icon is-small is-left">
            <i className="fa fa-exclamation-triangle"></i>
          </span>
          {'  '}
          {choosenLang.alertCodeNotOk}
        </div>
      )}
      <div className="field">
        <label className="label">{choosenLang.setCode + mail + ' '}</label>
        <div className="control has-icons-right">
          <input
            className={'input'}
            type="text"
            placeholder={choosenLang.code}
            value={code}
            onChange={onCodeChange}
          />
        </div>
      </div>
      <div className="field is-grouped">
        <p className="control">
          <button
            className={'button ' + (doSubscribe ? 'is-info ' : 'is-primary')}
            onClick={() => onConfirmCode(code)}
          >
            {choosenLang.continue}
          </button>
        </p>
        <p className="control">
          <button className="button is-light " onClick={onCancel}>
            {choosenLang.cancel}
          </button>
        </p>
      </div>
    </>
  )
}

export default CheckCode
